import { z } from 'zod';

const OrganizationSchema = z
  .object({
    _id: z.string(),
    name: z.string(),
    description: z.string(),
    logoUrl: z.string().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
    __v: z.number(),
  })
  .passthrough();

const CriteriaSchema = z
  .object({
    criteriaType: z.string(),
  })
  .passthrough();

const AssessmentTemplateSectionSchema = z
  .object({
    shouldShowScore: z.boolean(),
    name: z.string(),
    timeLimit: z.number(),
    order: z.number(),
    criteria: CriteriaSchema,
    _id: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();

const AssessmentTemplateSchema = z
  .object({
    _id: z.string(),
    name: z.string(),
    description: z.string(),
    assessmentTemplateSections: z.array(AssessmentTemplateSectionSchema),
    createdAt: z.string(),
    updatedAt: z.string(),
  })
  .passthrough();

export class EdetAccessCodeGroup {
  constructor(
    public _id: string,
    public name: string,
    public organization: z.infer<typeof OrganizationSchema>,
    public usageLimit: number,
    public assessmentTemplate: z.infer<typeof AssessmentTemplateSchema>,
    public createdAt: string,
    public updatedAt: string,
    public __v?: number
  ) {}

  public static zodSchema = z
    .object({
      _id: z.string(),
      name: z.string(),
      organization: OrganizationSchema,
      usageLimit: z.number(),
      assessmentTemplate: AssessmentTemplateSchema,
      createdAt: z.string(),
      updatedAt: z.string(),
      __v: z.number().optional(),
    })
    .passthrough();

  public static fromJson(json: unknown): EdetAccessCodeGroup {
    const validJson = this.check(json);
    const accessCodeGroup = new EdetAccessCodeGroup(
      validJson._id,
      validJson.name,
      validJson.organization,
      validJson.usageLimit,
      validJson.assessmentTemplate,
      validJson.createdAt,
      validJson.updatedAt,
      validJson.__v
    );
    return accessCodeGroup;
  }

  public static fromJsonArray(jsonArray: unknown): EdetAccessCodeGroup[] {
    const validJsonArray = this.checkArray(jsonArray);
    return validJsonArray.map((json) => this.fromJson(json));
  }

  public static check(json: unknown): z.infer<typeof this.zodSchema> {
    return this.zodSchema.parse(json);
  }

  public static checkArray(jsonArray: unknown): z.infer<typeof this.zodSchema>[] {
    return z.array(this.zodSchema).parse(jsonArray);
  }
}
